import { CircleTickIcon } from '../../../assets/icons/CircleTickIcon';

export const applianceCareRadioOptionContent = [
  {
    icon: CircleTickIcon,
    title: 'Accidental damage and breakdown coverage',
    description: '(broken parts, mechanical issues)',
  },
  {
    icon: CircleTickIcon,
    title: "New appliance if it can't be fixed",
  },
  { icon: CircleTickIcon, title: 'No deductibles' },
  { icon: CircleTickIcon, title: 'Monthly plan, cancel anytime' },
];
